/* 
Copyright (c) Karsten Jeske and John Firth
This source code is licensed under the proprietary license found in the
LICENSE file in the root directory of this source tree.
*/

import React from "react"

export interface CalculateButtonProps {
  readonly loading: boolean
  readonly onClick: (event: React.MouseEvent) => void
  readonly id?: string
}

// AIDEV-NOTE: issue #158. Both labels are wrapped in a `<span>` so that no branch
// puts a bare text node directly inside the `<button>`. Chromium's built-in page
// translator re-parents bare text nodes into `<font>` wrappers, and React then
// removes the node by identity from the parent it recorded - the `NotFoundError:
// Failed to execute 'removeChild' on 'Node'` seen in Sentry (JAVASCRIPT-REACT-8),
// exclusively from Chromium browsers in non-anglophone locales. Element children
// are left alone by the translator, so React's removal still finds them. This
// mitigates a known-unfixed upstream React defect (facebook/react#11538); it is
// not a guarantee, and SentryErrorBoundary remains the backstop. Do not replace
// this with `translate="no"` - that disables translation for exactly the users
// affected.
const CalculateButton: React.FC<CalculateButtonProps> = ({
  loading,
  onClick,
  id = "calculate-results-button",
}) => {
  return (
    <div className="mt-5">
      <button className="btn btn-primary btn-lg" id={id} disabled={loading} onClick={onClick}>
        {loading ? (
          <>
            <span
              className="spinner-border spinner-border-sm me-2"
              role="status"
              aria-hidden="true"
            ></span>
            <span>Calculating...</span>
          </>
        ) : (
          <span>Calculate Results</span>
        )}
      </button>
    </div>
  )
}

export default CalculateButton
